import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Check if embedded in another website
var hostname = window.location.hostname.split('.');
let embedded = (hostname.slice(-3).join('.') != 'mardome.co.uk');
const IS_EMBEDDED = (window.location.hostname == 'localhost') ? (process.env.VUE_APP_FORCE_EMBED_MODE === 'true') : embedded;

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {

    if (savedPosition) {
        // savedPosition is only available for popstate navigations.
        return savedPosition
    } else {
        const position = {}

        // scroll to anchor by returning the selector
        if (to.hash) {
            position.selector = to.hash

            // specify offset of the element
            if (to.hash === '#anchor2') {
                position.offset = { y: 100 }
            }

            if (document.querySelector(to.hash)) {
                return position
            }

            // if the returned position is falsy or an empty object,
            // will retain current scroll position.
            return false
        }

        return new Promise(resolve => {
            // check if any matched route config has meta that requires scrolling to top
            if (to.matched.some(m => m.meta.scrollToTop)) {
                // coords will be used if no selector is provided,
                // or if the selector didn't match any element.
                position.x = 0
                position.y = 0
            }

            // wait for the out transition to complete (if necessary)
            this.app.$root.$once('triggerScroll', () => {
                // if the resolved position is falsy or an empty object,
                // will retain current scroll position.
                // setTimeout(
                //     () => resolve(position)
                //     , 1000
                // );
                resolve(position)
            })
        })
    }
}

export default new Router({
    mode: (IS_EMBEDDED) ? 'hash' : 'history', // Set Router mode based on domain name
    base: '/',
    scrollBehavior,
    routes: [
        {
            path: '/',
            name: 'home',
            props: true,
            component: () => (IS_EMBEDDED) ? import('./views/Popular.vue') : import('./views/Home.vue'),
            meta: {
                scrollToTop: false
            }
        },
        {
            path: '/products/:range_slug',
            name: 'popular',
            component: () => import('./views/Popular.vue'),
            props: true,
            meta: {
                scrollToTop: true
            }
        },
        {
            path: '/products/:range_slug/:model_slug/:hash?',
            name: 'model',
            component: () => import('./views/Model.vue'),
            props: true,
            meta: {
                scrollToTop: true
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue'),
            meta: {
                scrollToTop: true
            }
        },
        {
            path: '*',
            name: '404',
            component: () => import('./views/NotFound.vue'),
            meta: {
                scrollToTop: true
            }
        }
    ]
})



